// types/appointment.ts (nuevo archivo)
export enum AppointmentStatus {
  UPCOMING = "UPCOMING", // Cita futura (antes de start_date)
  SCHEDULED = "SCHEDULED", // Dentro del horario pero sin check-in (backup)
  LATE = "LATE", // Ya pasó start_date pero aún no end_date, sin check-in
  MISSED = "MISSED", // Ya pasó end_date sin check-in
  IN_PROGRESS = "IN_PROGRESS", // Check-in registrado, no check-out
  COMPLETED = "COMPLETED", // Check-out registrado
}

export interface AppointmentDetail {
  // Basic info
  id: number;
  graph_event_id: string;
  host_email: string;
  guest_email: string;
  guest_name: string;
  start_date: string;
  end_date: string;
  office_Location?: string;
  indications?: string;
  is_active: boolean;
  guest_cedula?: string;
  appointment_building_id: number;

  // Building info
  building_name?: string;
  building_description?: string;

  // Check-in info
  checkin_time?: string;
  checkin_building_id?: number;
  checkin_parking_id?: number;
  companions?: string;
  checkin_notes?: string;
  checked_in_by?: string;
  checkin_building_name?: string;
  checkin_building_description?: string;

  // Check-out info
  checkout_time?: string;
  checkout_notes?: string;
  checked_out_by?: string;

  // Status and calculations
  current_status: AppointmentStatus;
  status_code: number;
  is_within_time_window: number;
  minutes_until_start: number;
  minutes_since_start: number;
  minutes_remaining: number;
  duration_minutes?: number;
  time_elapsed_percent: number;

  // Audit
  appointment_created_by?: string;
  appointment_created_date?: string;
  appointment_host_checkout_time?: string;
}

export interface Acompanante {
  visita_id: number;
  cedula: string;
  nombre: string;
  email: string;
}
